/**
 * Created by hp on 2017/8/23.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'react-weui';
import axios from 'axios';
import qs from 'qs';
import {Page, WKError} from '../components';
import {WKPreload} from '../components/wk';
import {getJsonFromUrl} from '../utils';
import '../css/page/RelaySettingAcceptPage.css';
import errorImg from '../images/no-source.png'


class RelaySettingAcceptPage extends Component {
    constructor() {
        super();

        this.handleRelayLecture = this.handleRelayLecture.bind(this);
        this.state = {
            initialized: false,
            inviter: {},
            lecture: {},
        }
    }

    handleRelayLecture() {
        const {lecture} = this.state;
        let data = getJsonFromUrl();
        axios.post(`/api/relay/lecture/${lecture.id}/accept_invite`, qs.stringify(data)).then((res) => {
           if (res.data.code === 0) {
               window.location = `/lecture/${res.data.data.lecture_id}`;
           } else {
               this.page.showAlert(res.data.msg);
           }
        });
    }

    componentDidMount() {
        const {id} = this.props.params;
        axios.get(`/api/relay/lecture/${id}/accept_invite_info` + window.location.search).then(res => {
            if (res.data.code === 0) {
                let data = res.data.data;
                this.setState({initialized: true, inviter: data.inviter, lecture: data.lecture});
            } else if (res.data.code === 5) {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg,
                        img: errorImg,
                        href: '/account/modify',
                        btn: '立即创建'
                    }
                })
            } else {
                this.props.dispatch({
                    type: 'ERROR_SHOW',
                    payload: {
                        tips: res.data.msg,
                        img: errorImg,
                        href: '/',
                        btn: '回到首页'
                    }
                })
            }
        }).catch(error => {
            this.props.dispatch({
                type: 'ERROR_SHOW',
                payload: {
                    tips: '糟糕！访问的页面被外星人挟持啦～',
                    img: errorImg,
                    href: '/',
                    btn: '回到首页'
                }
            })
        });
    }

    render() {
        const {initialized, inviter, lecture} = this.state;
        const {error} = this.props;

        if (error.showError) {
            return (
                <div className="relay-setting-accept-page wk-inner-page">
                    <WKError />
                </div>
            )
        }

        if (!initialized) {
            return <WKPreload />
        }

        return (
            <Page parent={this} className="relay-setting-accept-page">
                <div className="wk-inner-page">
                    <div className="inner">
                        <div className="accept-card-content wk-screen-center">
                            <img src={lecture.cover_url} alt=""/>

                            <div className="accept-card-desc">
                                <p className="desc1">{inviter.nickname}邀请你转载《{lecture.name}》</p>
                                <p className="desc2">点击下方按钮，立即创建专属转载间</p>
                            </div>

                            <Button onClick={this.handleRelayLecture}>立即转载</Button>
                        </div>
                    </div>
                </div>
            </Page>
        )
    }
}

export default connect((state) => ({
    error: state.error,
}))(RelaySettingAcceptPage);



// WEBPACK FOOTER //
// ./src/pages/RelaySettingAcceptPage.js